module.exports = __webpack_public_path__ + "static/home-big-stack-230bd0769a8f95be1ac4024049650ba6.svg";